import { ref } from 'vue'
import { defineStore } from 'pinia'

import type { Check } from '../types'

export const useSfAssistantChecksCommentIds = defineStore(
  'assistantChecksCommentIds',
  () => {
    const commentIdsByCheckId = ref<Record<string, string[]>>({})

    function addCommentId(checkId: string, newCommentId: string): void {
      if (!commentIdsByCheckId.value[checkId].includes(newCommentId)) {
        commentIdsByCheckId.value[checkId].push(newCommentId)
      }
    }

    function setCommentIds(checks: Check[]): void {
      commentIdsByCheckId.value = checks.reduce((acc, check) => {
        acc[check.id] = check.commentIds ?? []
        return acc
      }, {} as Record<string, string[]>)
    }

    return {
      setCommentIds,
      addCommentId,
      commentIdsByCheckId,
    }
  }
)
